module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"integrations":"Интеграции","settings":"Настройки","account":"Аккаунт","templates":"Шаблоны писем","payment":"Оплата","users":"Пользователи"}}')
  delete Component.options._Ctor
}
